import { render, staticRenderFns } from "./TriggerAuthorDataUnitAgent.vue?vue&type=template&id=b9d3e0c8&scoped=true&"
import script from "./TriggerAuthorDataUnitAgent.vue?vue&type=script&lang=ts&"
export * from "./TriggerAuthorDataUnitAgent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d3e0c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
